import { useEffect, useState } from "react";
import apiAgent from "../api/apiAgent";
import { useNavigate } from "react-router";
import { tMsg } from "../components/ToastNotifications";
import { useAtom, useSetAtom } from "jotai";
import { loginStatusAtom, userAtom } from "../atoms";
import { Link } from "react-router-dom";

interface ILoginData {
  name: string;
  password: string;
}

const defaultLoginData = {
  name: "",
  password: "",
};

const Authenticate = (): JSX.Element => {
  const navigate = useNavigate();
  const [data, setData] = useState<ILoginData>(defaultLoginData);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [loginStatus, setLoginStatus] = useAtom(loginStatusAtom);
  const setUsername = useSetAtom(userAtom);

  useEffect(() => {
    validateAuthentication();
  }, []);

  const validateAuthentication = async () => {
    // If already logged in, navigate to home page
    if (loginStatus === true) {
      navigate("/home");
      return;
    }
    // If already logged in, navigate to home page
    try {
      const response = await apiAgent.Auth.validate();
      if (response.status === 200) {
        setLoginStatus(true);
        setUsername(response.data || null);
        navigate("/home");
      }
    } catch (err) {
      console.log("No valid login status");
    }
  };

  const authenticate = async () => {
    try {
      // authenticate here

      const params = {
        name: data.name,
        password: data.password,
      };

      const response = await apiAgent.Auth.login(params);
      if (response.status === 200) {
        setLoginStatus(true);
        tMsg.success("Login successful");
        const validateResponse = await apiAgent.Auth.validate();
        setUsername(validateResponse.data || null);
        navigate("/home");
      }
    } catch (err) {
      console.log(err);
      setErrorMessage("Invalid login details");
      setData(defaultLoginData);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (
      !data.name ||
      data.name.length < 1 ||
      !data.password ||
      data.password.length < 1
    ) {
      setErrorMessage("Valid username & password required");
      return;
    }
    authenticate();
  };

  return (
    <div
      className="w-full h-full grid place-content-center bg-cover gap-4"
      style={{ backgroundImage: "url(/assets/ns_cms_background.jpg)" }}
    >
      <div className="flex justify-center w-full">
        <img src="/assets/ns_login_logo.png" className="w-[250px]" />
      </div>
      <div className="w-96 py-8 ">
        <h1 className="text-white text-center w-full text-xl font-bold mb-3">
          CMS Login
        </h1>
        <div className="h-5 w-full text-center text-red-500 font-medium text-sm mb-1">
          {errorMessage || ""}
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col space-y-4 text-black">
            <input
              className="p-2 bg-gray-300"
              name="name"
              type="text"
              placeholder="Username"
              value={data.name}
              onChange={handleChange}
            />
            <input
              className="p-2 bg-gray-300"
              name="password"
              type="password"
              placeholder="Password"
              value={data.password}
              onChange={handleChange}
            />
            <button
              type="submit"
              className="bg-primaryColor text-white p-2 transition hover:bg-white hover:text-primaryColor border border-primaryColor"
            >
              Login
            </button>
          </div>
        </form>
        <div className="text-white/70 hover:text-white text-sm font-bold transition text-center pt-4">
          <Link to="/request_reset">Forgot your password?</Link>
        </div>
      </div>
    </div>
  );
};

export default Authenticate;
